import React from "react";
import "./style.css";
import { useEffect, useState } from "react";
// import { SidebarContext } from "../../../component/Context/SidebarContext";
import { useNavigate } from "react-router-dom";
import { FetchGames } from "../../../GameServices/GameServices";
import { useAuthContext } from "../../../AuthContext";
import { Link } from "react-router-dom";

export const GamesMbl = () => {
  const { isMobile } = useAuthContext();
  // console.log("is Mobileeeeeeeeeeeeeeeeeeeeeeeeeee", isMobile);
  // const { dispatch, state } = useContext(SidebarContext);
  const [games, setGames] = useState([]);
  const [hover, setHover] = useState("");
  const navigate = useNavigate();
  // useEffect(() => {
  //   dispatch({ type: "SEARCH_BTN", data: true });
  //   return function () {
  //     dispatch({ type: "SEARCH_BTN", data: false });
  //   };
  // }, []);
  useEffect(() => {
    fetchGames();
  }, []);

  const playGameHandler = (gameName) => {
    navigate(`/playgame/${gameName}`);
  };
  const fetchGames = async () => {
    let { data } = await FetchGames();
    setGames(data);
  };

  return (
    <div className="main-mbl-stage">
      {/* <div className="container">
        <div className="flex-div">
          <div className="lg-box">
            <img
              src={
                hover === 0
                  ? require("../../../Assets/img/tetris.gif")
                  : require("../../../Assets/img/img1-11.png")
              }
              onClick={() => {
                playGameHandler("tetris");
              }}
              onMouseEnter={() => setHover(0)}
              onMouseLeave={() => setHover("")}
            />
          </div>
          <div className="sm-box">
            <img src={require("../../../Assets/img/img2-1.png")} />
            <img src={require("../../../Assets/img/img3-1.jpg")} />
          </div>
        </div>

        <div className="flex-div row-elemt">
          <div className="sm-box ">
            <img src={require("../../../Assets/img/img4-1.png")} />
            <img src={require("../../../Assets/img/img5.jpg")} />
            <img src={require("../../../Assets/img/img6.png")} />
          </div>
        </div>

        <div className="flex-div">
          <div className="sm-box">
            <img src={require("../../../Assets/img/cut.png")} />
            <img src={require("../../../Assets/img/img8.png")} />
          </div>
          <div className="lg-box">
            <img
              src={require("../../../Assets/img/img9.png")}
              onClick={
                isMobile
                  ? () => {
                      playGameHandler("stack");
                    }
                  : () => {
                      playGameHandler("stack");
                    }
              }
              onMouseEnter={() => setHover(1)}
              onMouseLeave={() => setHover("")}
            />
          </div>
        </div>

        <div className="flex-div row-elemt">
          <div className="sm-box ">
            <img
              src={require("../../../Assets/img/car.png")}
              onClick={
                isMobile
                  ? () => playGameHandler("road")
                  : () => {
                      playGameHandler("road");
                    }
              }
            />
            <img src={require("../../../Assets/img/img10.png")} />
            <img
              src={require("../../../Assets/img/game4.png")}
              onClick={isMobile ? () => playGameHandler("2048") : null}
            />
          </div>
        </div>

        <div className="flex-div row-elemt f-mb-5">
          <div className="sm-box ">
            <img
              src={require("../../../Assets/img/game1.png")}
              onClick={isMobile ? () => playGameHandler("tetris") : null}
            />
            <img src={require("../../../Assets/img/chess.png")} />
            <img src={require("../../../Assets/img/img13.png")} />
          </div>
        </div>
      </div> */}
      <section className="game-mbl-section">
        <div className="container-1280">
          <div className="row mobile-row">
            <div className="col-lg-12">
              <div className="images-mbl-row">
                <div className="images-mbl-col">
                  <img
                    src={hover === 0 ? require("../../../Assets/img/tetris.gif") : require("../../../Assets/img/img1-11.png")}
                    alt="tetris"
                    onClick={() => {
                      playGameHandler("Pacman");
                    }}
                    onMouseEnter={() => setHover(0)}
                    onMouseLeave={() => setHover("")}
                  />
                </div>
                <div className="images-mbl-col">
                  <img
                    src={require("../../../Assets/img/img2-1.png")}
                    alt=""
                    onClick={() => {
                      playGameHandler("FruitNinja");
                    }}
                  />
                </div>
                <div className="images-mbl-col">
                  <img src={require("../../../Assets/img/img3-1.jpg")} alt="" />
                </div>
                <div className="images-mbl-col">
                  <img src={require("../../../Assets/img/img4-1.jpg")} alt="" />
                </div>
                <div className="images-mbl-col">
                  <img
                    src={require("../../../Assets/img/img5.jpg")}
                    alt=""
                    onClick={() => {
                      playGameHandler("DinoJump");
                    }}
                  />
                </div>
                <div className="images-mbl-col">
                  <img
                    src={require("../../../Assets/img/img6.png")}
                    alt=""
                    onClick={() => {
                      playGameHandler("PaperToss");
                    }}
                  />
                </div>
                <div className="images-mbl-col">
                  <img src={require("../../../Assets/img/cut.png")} alt="" />
                </div>
                <div className="images-mbl-col">
                  <img
                    src={require("../../../Assets/img/img8.png")}
                    alt=""
                    onClick={
                      isMobile
                        ? () => {
                            playGameHandler("Bubbleshooter");
                          }
                        : () => {
                            playGameHandler("Bubbleshooter");
                          }
                    }
                    onMouseEnter={() => setHover(4)}
                    onMouseLeave={() => setHover("")}
                  />
                </div>
                <div className="images-mbl-col">
                  <img
                    src={require("../../../Assets/img/img9.png")}
                    alt=""
                    onClick={
                      isMobile
                        ? () => {
                            playGameHandler("stack");
                          }
                        : () => {
                            playGameHandler("stack");
                          }
                    }
                    onMouseEnter={() => setHover(1)}
                    onMouseLeave={() => setHover("")}
                  />
                </div>
                <div className="images-mbl-col">
                  <img
                    src={require("../../../Assets/img/car.png")}
                    onClick={
                      isMobile
                        ? () => playGameHandler("RoadFighter")
                        : () => {
                            playGameHandler("RoadFighter");
                          }
                    }
                    alt=""
                  />
                </div>
                <div className="images-mbl-col">
                  <img src={require("../../../Assets/img/img10.png")} alt="" />
                </div>
                <div className="images-mbl-col">
                  <img src={require("../../../Assets/img/game4.png")} alt="" onClick={isMobile ? () => playGameHandler("2048") : null} />
                </div>
                <div className="images-mbl-col">
                  <img src={require("../../../Assets/img/game1.png")} alt="" onClick={isMobile ? () => playGameHandler("tetris") : null} />
                </div>
                <div className="images-mbl-col">
                  <img src={require("../../../Assets/img/chess.png")} alt="" />
                </div>
                <div className="images-mbl-col">
                  <img src={require("../../../Assets/img/img13.png")} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="footer-fixed">
        <footer className="mobile-footer">
          <div className="btn-main">
            <img src={require("../../../Assets/img/btn.png")} alt="" />
          </div>

          <div className="container">
            <div className="bottom-area">
              <ul className="footer-l-txt">
                <Link to="/">
                  <li>Home</li>
                </Link>
                <li>Tournament</li>
              </ul>
              <ul className="footer-r-txt">
                <li>NFTs</li>
                <li>Profile</li>
              </ul>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};
